import React, {useState} from 'react';
import {CopyToolTip} from './CopyToolTip';

interface Props {
  copyText: string;
}

export default ({copyText}: Props) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const copyTextToClipboard = (text: string) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
  };
  
  if (!copyText) return null;
  
  return (
    <div
      onClick={() => {
        setIsTooltipVisible(true);
        copyTextToClipboard(copyText);
        setTimeout(() => {
          setIsTooltipVisible(false);
        }, 2000);
      }}
      className="flex items-center justify-center h-5">
      <CopyToolTip isVisible={isTooltipVisible} />
    </div>
  );
};
